import { render } from "./zcfzb.vue?vue&type=template&id=028110b0&scoped=true&ts=true"
import script from "./zcfzb.vue?vue&type=script&lang=ts"
export * from "./zcfzb.vue?vue&type=script&lang=ts"

import "./zcfzb.vue?vue&type=style&index=0&id=028110b0&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028110b0"]])

export default __exports__